import React, { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('pt');

    useEffect(() => {
        const savedLanguage = localStorage.getItem("siteLanguage");
        const browserLanguage = navigator.language.split('-')[0];
        const supportedLanguages = ['pt', 'en', 'es'];

        if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
            setLanguage(savedLanguage);
        } else if (supportedLanguages.includes(browserLanguage)) {
            setLanguage(browserLanguage);
        }
    }, []);

    const changeLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem("siteLanguage", lang);
        window.location.reload(); 
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
